import { ButtonTypes, SimplifiedIcons } from '@cox/core-ui8/dist/Button'

export interface ReactOliverProps {
  headline: string
  inputText: string
  disclaimer: string
  iconPath: string
  buttonStates: string
  buttonTypes: ButtonTypes
  cqType: string
  cqPath: string
  isInEditor: boolean
  text: string
  simplified?: SimplifiedIcons
  icon?: string
  anchor?: string
  id?: string
  top?: boolean
  right?: boolean
  bottom?: boolean
  left?: boolean
  lob?: string
  backgroundColor?: OliverBackgroundColor
}

export enum OliverBackgroundColor {
  grey = 'grey',
  transparent = 'transparent'
}
